import BigNumber from 'bignumber.js';
import { BigNumberConstructable } from '../lib/customType';

export default function formatPercentage(num: BigNumberConstructable, decimalNumber = 2): string {
  return new BigNumber(num).multipliedBy(100).decimalPlaces(decimalNumber).toFixed();
}
